function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_radial_7063_18893)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7063_18893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.672 27.2445C27.672 24.669 25.5755 22.5724 22.9999 22.5724C20.4244 22.5724 18.3279 24.669 18.3279 27.2445C18.3279 29.82 20.4244 31.9165 22.9999 31.9165C25.5754 31.9165 27.6719 29.82 27.672 27.2445ZM25.0206 25.2238C25.2157 25.4189 25.2157 25.7351 25.0206 25.9302L21.6856 29.2651C21.4906 29.4602 21.1743 29.4602 20.9792 29.2651C20.7842 29.0701 20.7842 28.7538 20.9792 28.5587L24.3138 25.2234C24.509 25.0282 24.8256 25.0284 25.0206 25.2238ZM24.7508 28.5824C25.0266 28.5824 25.2501 28.8067 25.2501 29.0824C25.2501 29.3582 25.0266 29.5825 24.7508 29.5825C24.4751 29.5825 24.2515 29.3582 24.2515 29.0824C24.2515 28.8067 24.4751 28.5824 24.7508 28.5824ZM21.0753 24.9064C21.3512 24.9064 21.575 25.1301 21.575 25.4061C21.575 25.6821 21.3512 25.9058 21.0753 25.9058C20.7993 25.9058 20.5756 25.6821 20.5756 25.4061C20.5756 25.1301 20.7993 24.9064 21.0753 24.9064ZM15.8433 15.4313C16.1184 15.4313 16.3414 15.6563 16.3414 15.9314C16.3414 16.2065 16.1184 16.4315 15.8433 16.4315C15.5683 16.4315 15.3453 16.2065 15.3453 15.9314C15.3453 15.6563 15.5683 15.4313 15.8433 15.4313ZM17.7745 15.4313C18.0507 15.4313 18.275 15.6552 18.275 15.9314C18.275 16.2076 18.0507 16.4315 17.7745 16.4315C17.4983 16.4315 17.274 16.2076 17.274 15.9314C17.274 15.6552 17.4983 15.4313 17.7745 15.4313ZM19.7012 15.4313C19.9765 15.4313 20.1996 15.6561 20.1996 15.9314C20.1996 16.2067 19.9765 16.4315 19.7012 16.4315C19.4259 16.4315 19.2027 16.2067 19.2027 15.9314C19.2027 15.6561 19.4259 15.4313 19.7012 15.4313ZM31.9143 15.2523C31.9143 14.6079 31.3916 14.0853 30.7473 14.0853H15.2525C14.6082 14.0853 14.0855 14.6079 14.0855 15.2523V17.7767H31.9143V15.2523ZM28.6713 27.2445C28.6713 28.0722 28.4916 28.8582 28.1716 29.5679H30.7473C31.3916 29.5679 31.9142 29.0459 31.9143 28.4017V18.7769H14.0855V28.4017C14.0857 29.0459 14.6083 29.5679 15.2525 29.5679H17.8282C17.5082 28.8582 17.3285 28.0722 17.3285 27.2445C17.3285 24.1167 19.8721 21.5731 22.9999 21.5731C26.1277 21.5731 28.6713 24.1167 28.6713 27.2445ZM32.9137 28.4017C32.9135 29.5982 31.9438 30.568 30.7473 30.568H27.5914C26.5598 31.9893 24.8868 32.9159 22.9999 32.9159C21.113 32.9159 19.44 31.9893 18.4084 30.568H15.2525C14.056 30.568 13.0863 29.5982 13.0862 28.4017V15.2523C13.0862 14.0557 14.0559 13.0859 15.2525 13.0859H30.7473C31.9439 13.0859 32.9137 14.0557 32.9137 15.2523V28.4017Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7063_18893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.560974 42.4615) rotate(-41.5346) scale(60.7023 163.609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB",
    style: {
      stopColor: "#0D56EB",
      stopColor: "color(display-p3 0.0510 0.3373 0.9216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9",
    style: {
      stopColor: "#0640B9",
      stopColor: "color(display-p3 0.0235 0.2510 0.7255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7063_18893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(13 13)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/codeIcon.f2758bbc83aeea3e4be02d678bda3e46.svg";
export { ForwardRef as ReactComponent };